import { isGlobalFeatureEnabled } from "owa-feature-flags";
import type { Suggestion } from "../data/schema/SuggestionSet";
import { SuggestionKind } from "../data/schema/SuggestionSet";

export default function getTextSuggestionTelemetryMetadata(suggestion: Suggestion, position: number): Map<string, string> | undefined {
    if (!isGlobalFeatureEnabled("sea-peopleKeywordAsTextSuggestion") ||
        suggestion.kind !== SuggestionKind.PeopleKeyword) {
        return undefined;
    }
    
    return new Map<string, string>([
        ["TextSuggestionType", "PeopleKeywordAsText"],
        ["Position", position.toString()],
    ]);
}

export function getTextSuggestionsTelemetryMetadata(suggestions: readonly Suggestion[]): Map<string, string> | undefined {
    const textSuggestionTypes: string[] = [];
    const positions: string[] = [];
    
    for (const [index, suggestion] of suggestions.entries()) {
        const metadata = getTextSuggestionTelemetryMetadata(suggestion, index + 1);
        if (metadata) {
            textSuggestionTypes.push(metadata.get("TextSuggestionType") ?? "PeopleKeywordAsText");
            positions.push(metadata.get("Position") ?? (index + 1).toString());
        }
    }
    
    if (textSuggestionTypes.length === 0) {
        return undefined;
    }
    
    return new Map<string, string>([
        ["TextSuggestionType", textSuggestionTypes.join(",")],
        ["Position", positions.join(",")],
    ]);
}
